<div>
  <app-floorplan-toggle-display-mode [activeFloorplan]="floorplan"></app-floorplan-toggle-display-mode>
  <app-floorplan-toggle-selection-mode [activeFloorplan]="floorplan"></app-floorplan-toggle-selection-mode>
  <app-floorplan-menu-item-buttons>
    <app-toggle-visibility-button [visible]="visible" (toggleEvent)="visibilityUpdated($event)"> </app-toggle-visibility-button>
    <app-toggle-item-text-visibility-button
      [itemTextVisible]="itemTextVisible"
      (toggleEvent)="itemTextVisibilityUpdated($event)"
    ></app-toggle-item-text-visibility-button>
    <app-toggle-lock-button [locked]="locked" (toggleEvent)="lockUpdated($event)"> </app-toggle-lock-button>
  </app-floorplan-menu-item-buttons>
</div>
